import React from 'react';

class PublicIcon extends React.Component {
  render() {
    return (
      <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="24.2"
        viewBox="0 0 40 24.2"
      >
        <g id="XMLID_786_">
          <path
            id="XMLID_789_"
            style={{ fill: '#C6C6C6' }}
            d="M36.9 5.5c0 1.1-.9 1.9-1.9 1.9h-.3c-.2.3-.5.6-.8.9.3.1.7.2 1.1.2 1.6 0 3-1.3 3-3 0-1.6-1.3-3-3-3h-.3c.2.3.4.7.5 1.1 1 .1 1.7.9 1.7 1.9z"
          />
          <g id="XMLID_787_">
            <path
              id="XMLID_788_"
              style={{ fill: '#C6C6C6' }}
              d="M40 13.9L38.5 10h-.1c-.1 0-1-.4-2.1-.6l.1.2.4 1c.4.1.8.2 1.1.3l.8 2.2c-.2 0-.6.1-.9.1l.4 1v.1c.8-.1 1.3-.2 1.3-.2l.5-.2z"
            />
          </g>
        </g>
        <g id="XMLID_782_">
          <path
            id="XMLID_785_"
            style={{ fill: '#C6C6C6' }}
            d="M5.3 7.4H5c-1 0-1.9-.8-1.9-1.9 0-1 .7-1.7 1.6-1.9.1-.4.3-.7.5-1.1H5c-1.6 0-3 1.3-3 3 0 1.6 1.3 3 3 3 .4 0 .7-.1 1.1-.2-.3-.3-.6-.6-.8-.9z"
          />
          <g id="XMLID_783_">
            <path
              id="XMLID_784_"
              style={{ fill: '#C6C6C6' }}
              d="M2.3 13.2c-.3 0-.6-.1-.8-.1l.8-2.2c.2-.1.6-.2 1-.3l.4-1 .1-.2c-1.1.2-2.1.6-2.1.6l-.2.1L0 13.9l.7.1s.6.1 1.3.2v-.1l.3-.9z"
            />
          </g>
        </g>
        <g id="XMLID_601_">
          <g id="XMLID_603_">
            <g id="XMLID_605_">
              <g id="XMLID_766_">
                <path
                  id="XMLID_42_"
                  style={{ fill: '#999999' }}
                  d="M20 23.7c-3.9 0-8.8-.7-9.3-.8L9 22.5l3.1-8.1.6-.2c.3-.1 2.2-.8 4.3-1.3-2.1-1.1-3.6-3.3-3.6-5.9 0-3.6 2.9-6.6 6.6-6.6s6.6 2.9 6.6 6.6c0 2.5-1.4 4.8-3.6 5.9 2.3.5 4.3 1.2 4.4 1.3l.6.2 3.1 8.1-1.6.3c-.7.1-5.6.9-9.5.9zm-7.3-3.3c1.8.2 4.8.6 7.2.6 2.5 0 5.4-.3 7.3-.6l-1.4-3.8c-1.1-.4-3.8-1.2-5.8-1.2s-4.7.9-5.8 1.2l-1.5 3.8zM20 3.2c-2.1 0-3.8 1.7-3.8 3.8 0 2.1 1.7 3.8 3.8 3.8s3.8-1.7 3.8-3.8c0-2.1-1.7-3.8-3.8-3.8z"
                />
                <path
                  id="XMLID_35_"
                  style={{ fill: '#FFFFFF' }}
                  d="M20 1c3.3 0 6 2.7 6 6.1 0 3.1-2.4 5.7-5.4 6 2.9.2 6.3 1.5 6.5 1.6l.4.1 2.8 7.4-1 .2c-.2 0-5.2.8-9.3.8-4 0-9-.8-9.3-.8l-1-.2 2.8-7.4.4-.1c.2-.1 3.5-1.4 6.5-1.6-3-.3-5.4-2.9-5.4-6-.1-3.4 2.6-6.1 6-6.1m0 10.4c2.4 0 4.3-1.9 4.3-4.3s-2-4.3-4.3-4.3c-2.4 0-4.3 2-4.3 4.3-.1 2.4 1.9 4.3 4.3 4.3m0 10c2.8 0 6.3-.4 7.9-.7l-1.8-4.6c-1-.4-4-1.3-6.2-1.3s-5.2 1-6.1 1.3L12 20.8c1.7.2 5.1.6 8 .6M20 0c-3.9 0-7.1 3.2-7.1 7.1 0 2.3 1.1 4.3 2.8 5.6-1.8.5-3.1 1-3.2 1l-.4.1-.4.2-.2.4-2.8 7.4-.4 1.1 1.2.2 1 .2c.5.1 5.4.8 9.4.8s8.9-.8 9.4-.8l1-.2 1.2-.2-.4-1.1-2.8-7.4V14l-.4-.2-.4-.1c-.1 0-1.5-.6-3.3-1 1.7-1.3 2.8-3.3 2.8-5.6C27 3.2 23.9 0 20 0zm0 10.4c-1.8 0-3.3-1.5-3.3-3.3 0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3zm-5.4 6.5c1.1-.4 3.6-1.1 5.4-1.1 1.8 0 4.3.7 5.4 1.1l1.1 3c-1.8.2-4.4.5-6.6.5-2.2 0-4.7-.3-6.5-.5l1.2-3z"
                />
              </g>
              <g id="XMLID_742_">
                <path
                  id="XMLID_765_"
                  style={{ fill: '#999999' }}
                  d="M14.1 11h-.4c-1.7 0-3-1.4-3-3 0-1.5 1.1-2.8 2.6-3 .2-.6.5-1.2.8-1.7h-.4C11 3.2 8.9 5.3 8.9 8c0 2.6 2.1 4.8 4.8 4.8.6 0 1.2-.1 1.7-.3-.5-.5-1-1-1.3-1.5z"
                />
                <path
                  id="XMLID_764_"
                  style={{ fill: '#999999' }}
                  d="M29.4 8c0 1.7-1.4 3-3 3-.2 0-.4 0-.5-.1-.3.5-.8 1-1.3 1.4.6.2 1.2.4 1.8.4 2.6 0 4.8-2.1 4.8-4.8 0-2.6-2.1-4.8-4.8-4.8h-.5c.3.5.6 1.1.8 1.7 1.5.3 2.7 1.6 2.7 3.2z"
                />
                <g id="XMLID_748_">
                  <g id="XMLID_759_">
                    <path
                      id="XMLID_763_"
                      style={{ fill: '#999999' }}
                      d="M9.3 20.2c-.5-.1-1-.1-1.3-.2l1.3-3.5c.4-.1.9-.3 1.6-.5l.6-1.7.1-.3c-1.7.3-3.3.9-3.3 1l-.3.3-2.3 6.2 1 .2c.1 0 .9.1 2 .3v-.1l.6-1.7z"
                    />
                    <g id="XMLID_760_">
                      <path
                        id="XMLID_762_"
                        style={{ fill: '#C6C6C6' }}
                        d="M7.9 7.4c-1-.4-1.6-1.3-1.6-2.5 0-1.5 1.2-2.7 2.7-2.7.7 0 1.4.3 1.8.7.3-.2.7-.3 1-.5-.6-.7-1.7-1.3-2.8-1.3-2.1 0-3.8 1.7-3.8 3.8 0 1.7 1.2 3.2 2.7 3.6v-.6-.5z"
                      />
                      <path
                        id="XMLID_761_"
                        style={{ fill: '#C6C6C6' }}
                        d="M7.2 14.5l.4-.2.4-.1s.3-.1.8-.3c-1.8 0-3.8-.2-4.8-.4l1.1-2.9c.5-.2 1.9-.6 3.1-.8-.1-.3-.2-.7-.3-1-1.6.2-3.3.9-3.4.9l-.2.1-1.8 4.6.7.1c.1 0 1.9.3 3.8.4l.2-.4z"
                      />
                    </g>
                  </g>
                  <g id="XMLID_749_">
                    <path
                      id="XMLID_758_"
                      style={{ fill: '#999999' }}
                      d="M34.4 21.4l-2.3-6.2-.4-.1c-.1 0-1.7-.6-3.4-1l.1.3.6 1.6c.7.2 1.3.4 1.7.5L32 20c-.4.1-.9.1-1.4.2l.6 1.6v.1c1.2-.1 2.1-.3 2.1-.3l1.1-.2z"
                    />
                    <g id="XMLID_755_">
                      <path
                        id="XMLID_757_"
                        style={{ fill: '#C6C6C6' }}
                        d="M31 2.2c1.5 0 2.7 1.2 2.7 2.7 0 1.1-.6 2-1.6 2.5v1.2c1.5-.5 2.7-1.9 2.7-3.6 0-2.1-1.7-3.8-3.8-3.8-1.1 0-2.2.5-2.9 1.3.4.1.7.3 1.1.5.4-.5 1.1-.8 1.8-.8z"
                      />
                      <path
                        id="XMLID_756_"
                        style={{ fill: '#C6C6C6' }}
                        d="M37.4 14.4l-1.7-4.6-.2-.1c-.1 0-1.7-.7-3.4-.9-.1.4-.1.7-.3 1 1.2.2 2.5.6 3 .8l1.1 2.9c-1 .1-2.9.4-4.6.4.4.1.7.3.8.3l.4.1.4.2.2.4c1.9-.1 3.7-.4 3.8-.4l.5-.1z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

export default PublicIcon;
